module.exports = __webpack_public_path__ + "static/media/close.0360f1c9.svg";